import { createBrowserRouter, Navigate } from 'react-router';
import { RequireAuth } from './auth/RequireAuth';
import { ApprovalThresholdsPage } from './features/approval-thresholds/ApprovalThresholdsPage';
import { CompanySettingsPage } from './features/company-settings/CompanySettingsPage';
import { CustomerDetailPage } from './features/customers/CustomerDetailPage';
import { CustomersPage } from './features/customers/CustomersPage';
import { DriverDetailPage } from './features/drivers/DriverDetailPage';
import { DriversPage } from './features/drivers/DriversPage';
import { FleetPage } from './features/fleet/FleetPage';
import { OwnerDetailPage } from './features/owners/OwnerDetailPage';
import { ReferenceDataPage } from './features/reference-data/ReferenceDataPage';
import { RolesPage } from './features/roles/RolesPage';
import { SecurityPage } from './features/security/SecurityPage';
import { TrailerDetailPage } from './features/trailers/TrailerDetailPage';
import { TruckDetailPage } from './features/trucks/TruckDetailPage';
import { UsersPage } from './features/users/UsersPage';
import { AppLayout } from './layouts/AppLayout';
import { OFFICE_SECTIONS } from './layouts/office-sections';
import { YardLayout } from './layouts/YardLayout';
import { LoginPage } from './pages/LoginPage';
import { NotFound } from './pages/NotFound';
import { SectionPage } from './pages/SectionPage';
import { YardTasksPage } from './pages/YardTasksPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/dispatch" replace /> },
          { path: 'account/security', element: <SecurityPage /> },
          { path: 'roles', element: <RolesPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'approval-thresholds', element: <ApprovalThresholdsPage /> },
          { path: 'reference-data', element: <ReferenceDataPage /> },
          { path: 'company', element: <CompanySettingsPage /> },
          { path: 'customers', element: <CustomersPage /> },
          { path: 'customers/:id', element: <CustomerDetailPage /> },
          { path: 'fleet', element: <FleetPage /> },
          { path: 'fleet/:id', element: <TruckDetailPage /> },
          { path: 'trailers/:id', element: <TrailerDetailPage /> },
          { path: 'owners/:id', element: <OwnerDetailPage /> },
          { path: 'drivers', element: <DriversPage /> },
          { path: 'drivers/:id', element: <DriverDetailPage /> },
          ...OFFICE_SECTIONS.filter(
            (section) => !['roles', 'users', 'approval-thresholds', 'reference-data', 'company', 'customers', 'fleet', 'drivers'].includes(section.slug),
          ).map((section) => ({
            path: section.slug,
            element: <SectionPage section={section} />,
          })),
        ],
      },
      {
        path: '/yard',
        element: <YardLayout />,
        children: [{ index: true, element: <YardTasksPage /> }],
      },
    ],
  },
  { path: '*', element: <NotFound /> },
]);
